import { useEffect, useMemo, useRef, useState } from "react"

import isEqual from "lodash.isequal"
import { useDispatch, useSelector } from "react-redux"

import {
  clearProviderBanner,
  hasProviderBanner as hasProviderBannerForAccount
} from "../../../Utils/anotherProviderBanner"
import UserCreators from "../../User/reducer"
import AnotherProviderBanner from "./AnotherProviderBanner"
import BalanceBanner from "./BalanceBanner"
import DaysCounterBanner from "./DayCounterBanner"
import DemoModeBanner from "./DemoModeBanner"

const Banners = () => {
  const { balance } = useSelector((state) => state.balance)
  const { userInfo } = useSelector((state) => state.auth)
  const prevUserInfoRef = useRef()
  const prevBalanceRef = useRef()
  const { bannerInfo, bannerInfoFetching } = useSelector((state) => state.user)
  const isMobile = useSelector((state) => state.nav.isMobile)
  const dispatch = useDispatch()
  const [firstLoad, setFirstLoad] = useState(true)
  const [hasProviderBanner, setHasProviderBanner] = useState(
    hasProviderBannerForAccount(userInfo?.current_business_account_id)
  )

  const isDemo = userInfo?.is_demo
  const isEmptyBaId = !userInfo.current_business_account_id
  const isLightMode = userInfo?.is_light_mode

  const bannerType = useMemo(() => {
    if (hasProviderBanner) return "provider"
    if (isDemo || isLightMode || isEmptyBaId) return "demo"
    if (bannerInfo?.days_counter?.show) return "days"
    return "balance"
  }, [isDemo, isLightMode, bannerInfo, hasProviderBanner])

  const getBannerInfo = () => {
    dispatch(UserCreators.getBannerInfoRequest())
  }
  const handleCloseProviderBanner = () => {
    clearProviderBanner(userInfo?.current_business_account_id)
    setHasProviderBanner(false)
  }

  useEffect(() => {
    setHasProviderBanner(hasProviderBannerForAccount(userInfo?.current_business_account_id))
  }, [userInfo?.current_business_account_id])

  useEffect(() => {
    const isUserEqual = isEqual(userInfo, prevUserInfoRef.current)
    const isBalanceEqual = isEqual(balance, prevBalanceRef.current)
    if (userInfo && (firstLoad || !isUserEqual || !isBalanceEqual)) {
      getBannerInfo()
    }
    setFirstLoad(false)
    const interval = setInterval(
      () => {
        getBannerInfo()
      },
      15 * 60 * 1000
    )
    prevUserInfoRef.current = userInfo
    prevBalanceRef.current = balance
    return () => clearInterval(interval)
  }, [userInfo, firstLoad, balance])

  if (bannerInfoFetching && !bannerInfo) return null

  if (!bannerInfo?.show_all_banners && !isEmptyBaId) return null

  if (userInfo?.is_loyalty_billing && bannerInfo?.balance?.amount < 0) return null

  return (
    <div style={{ width: "100%" }}>
      {bannerType === "provider" && (
        <AnotherProviderBanner handleCloseProviderBanner={handleCloseProviderBanner} />
      )}
      {bannerType === "demo" && !hasProviderBanner && <DemoModeBanner isMobile={isMobile} />}
      {bannerType === "days" && <DaysCounterBanner days={bannerInfo?.days_counter?.days_count} />}
      {bannerType === "balance" && (
        <BalanceBanner
          min={bannerInfo?.balance?.min_amount}
          current={bannerInfo?.balance?.amount}
          recommended={bannerInfo?.balance?.recommended_amount}
          updateBalance={getBannerInfo}
          isBlocked={bannerInfo?.is_ba_blocked}
          isLoyaltyBilling={
            bannerInfo?.is_loyalty_billing || bannerInfo?.is_excluded_from_auto_topup_recalc
          }
        />
      )}
    </div>
  )
}

export default Banners
